import { render } from "./ItemIndexBookUsed.vue?vue&type=template&id=206dd738&scoped=true"
import script from "./ItemIndexBookUsed.vue?vue&type=script&lang=js"
export * from "./ItemIndexBookUsed.vue?vue&type=script&lang=js"

import "./ItemIndexBookUsed.vue?vue&type=style&index=0&id=206dd738&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-206dd738"

export default script